"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { ColumnDefinition } from "./types";

interface CsvPreviewProps<T> {
  csvData: T[];
  columns: ColumnDefinition<T>[];
}

/**
 * Preview component for CSV data before import
 */
export function CsvPreview<T extends Record<string, any>>({
  csvData,
  columns,
}: CsvPreviewProps<T>) {
  if (csvData.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Preview ({csvData.length} items)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 max-h-60 overflow-y-auto">
          {csvData.slice(0, 5).map((row, index) => (
            <div key={index} className="p-3 border rounded-lg">
              <h4 className="font-medium">{String(row[columns[0].key])}</h4>
              <p className="text-sm text-gray-600 dark:text-gray-400">{String(row[columns[1]?.key] || "")}</p>
            </div>
          ))}
          {csvData.length > 5 && (
            <p className="text-sm text-gray-500 text-center">
              ... and {csvData.length - 5} more items
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
